import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "./TermsSection.css";

import bgImage from "../../assets/Institute/DSC_0110.JPG";
import overlay1 from "../../assets/cta.avif";
import overlay2 from "../../assets/cta.avif";
import overlay3 from "../../assets/cta.avif";

const PioneersSection1 = () => {
  const [count, setCount] = useState({ teachers: 0, schools: 0, years: 0 });

  useEffect(() => {
    let start = 0;
    const interval = setInterval(() => {
      start++;
      if (start <= 5500)
        setCount({
          teachers: start,
          schools: Math.floor(start / 20),
          years: Math.floor(start / 275),
        });
      else clearInterval(interval);
    }, 1);
    return () => clearInterval(interval);
  }, []);

  return (
    <section
      className="pioneers-revamp-1"
      id="pioneers-1"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="overlay-1"></div>

      <div className="pioneers-content-1">
        <motion.div
          className="pioneers-text-1"
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <h2>Welcome to NIECCE Edu Solutions Pvt Ltd!</h2>
          <p>Your privacy is paramount to us. This Privacy Policy outlines how we collect, use, disclose, and protect your personal information when you interact with us through our services, programs, and products.</p>
          <h3>1. Introduction</h3>
          <p>NIECCE Edu Solutions Pvt Ltd is committed to safeguarding your personal data. This policy applies to all information collected by us in connection with our preschool, early childhood education, publications, teacher training programs, courses, and related goods and services.</p>
          <h3>2. Data Collection</h3>
          <p>We collect information from various stakeholders, including parents, students, teachers, and partners. The types of data we collect include:</p>
          <ul className="pr-features-list">
          <li><b>Personal Information:</b> Name, contact details, date of birth, etc.-</li>
          <li><b>Educational Information:</b> Academic records, progress reports, etc.</li>
          <li><b>Financial Information:</b> Payment details, billing information, etc.</li>
          <li><b>Usage Data:</b> Information on how you interact with our services, such as usage statistics, preferences, etc.</li>
          </ul>
          <h3>3. Use of Data</h3>
          <p>We use the collected data for the following purposes:</p>
          <ul className="pr-features-list">          
          <li><b>Delivering Goods & Services:</b> To provide, manage, and improve our educational programs, products, and services.</li>
          <li><b>Personalisation:</b> To tailor our offerings to better meet your needs.</li>
          <li><b>Innovation:</b> To develop new products, services, and features.</li>
          <li><b>Monetisation:</b> To generate revenue through our offerings.</li>
          <li><b>Cross-Selling:</b> To promote and sell our different products and services.</li>
          <li><b>Improvement:</b> To analyze and enhance our programs and services.</li>
          </ul>
          <h3>4. Data Sharing and Disclosure</h3>
          <p>We may share your personal data with:</p>
          <ul className="pr-features-list">
          <li><b>Service Providers:</b> Third-party vendors who help us deliver our services.</li>
          <li><b>Affiliates:</b> Companies within our corporate family.</li>
          <li><b>Legal Requirements:</b> Authorities, when required by law.</li>
          </ul>
          <h3>5. Data Protection</h3>
          <p>We implement robust security measures to protect your data from unauthorized access, alteration, disclosure, or destruction.</p>
          <h3>6. User Rights</h3>
          <p>You have the right to access, correct, or delete your personal information. You can also object to or restrict certain processing of your data.</p>
          <h3>7. Changes to This Policy</h3>
          <p>We may update this Privacy Policy from time to time. Any changes will be posted on our website with the updated effective date.</p>
          <h3>8. Contact Us</h3>
          <p>If you have any questions or concerns about this Privacy Policy, please contact us at:</p>
          <p><b>NIECCE Edu Solutions Pvt Ltd Chandralayout, Bengaluru – 560040.</b></p>
          <p><b>info@niecce.com</b></p>
          <p><b>9886855700</b></p>
        </motion.div>

        
      </div>
    </section>
  );
};

export default PioneersSection1;
